import { isAnyOf } from '@reduxjs/toolkit';
import { startAppListening } from 'src/store/middleware/listenerMiddleware';
import { initThresholdSlice } from 'src/store/shared/threshold/factory';
import type { JsonFailure } from '@skynet/data-ws-core';
import { registerErrorMessage } from '@skynet/data-ws-core';
import { toThresholdUpdateData } from 'src/store/utils/thresholds';
import { isRecord } from 'src/utils/type-guards';

export enum LoanAccountThresholdCommands {
  AccountThresholds = 'AccountThresholds',
  UpsertAccountThreshold = 'UpsertAccountThreshold',
  DeleteAccountThreshold = 'DeleteAccountThreshold',
}

registerErrorMessage(LoanAccountThresholdCommands.DeleteAccountThreshold, {
  title: 'Delete Account Threshold Error',
  getDescription: (json: JsonFailure) => `${json.message}`,
});
registerErrorMessage(LoanAccountThresholdCommands.UpsertAccountThreshold, {
  title: 'Add Account Threshold Error',
  getDescription: (json: JsonFailure) => `${json.message}`,
});

const loanAccountsThresholdSlice = initThresholdSlice({
  prefix: 'loans',
  sliceName: 'threshold',
  commands: LoanAccountThresholdCommands,
});

startAppListening({
  matcher: isAnyOf(
    loanAccountsThresholdSlice.actions.setAccountThreshold,
    loanAccountsThresholdSlice.actions.deleteAccountThreshold,
  ),
  effect: (action, api) => {
    if ('payload' in action && isRecord(action.payload)) {
      api.dispatch(
        loanAccountsThresholdSlice.actions.setThresholdUpdateData(
          toThresholdUpdateData(action.payload),
        ),
      );
    }
  },
});

export const loanAccountsThresholdActions = loanAccountsThresholdSlice.actions;
export default loanAccountsThresholdSlice.reducer;
